"use client";

import Image from "next/image";
import Link from "next/link";

export function SwapperPortalSection() {
  const features = [
    {
      title: "Quests",
      description:
        "Earn 2 points for every $1 you trade or deposit on Swapper. Just use the platform, and watch your points grow.",
      image: "/assets/landing/quests.png",
      href: "/quests",
    },
    {
      title: "Referrals",
      description:
        "Share your referral link and get 10% of the points your friends earn through their volume. The more they use Swapper, the more you benefit.",
      image: "/assets/landing/referrals.png",
      href: "/referrals",
    },
    {
      title: "Rewards",
      description:
        "Get extra points for simple actions like following us on X, trading $50, or buying specific token. Tasks are quick and updated regularly.",
      image: "/assets/landing/rewards.png",
      href: "/leaderboard",
    },
  ];

  return (
    <section className="w-full py-12 md:py-16" style={{ backgroundColor: '#F1F3FF' }}>
      <div className="relative overflow-hidden">
        {/* Content */}
        <div className="relative z-10 px-6 md:px-12 lg:px-16 py-12 md:py-16 lg:py-20">
          {/* Header */}
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4" style={{ color: '#836FFF' }}>
              What is the Swapper Portal?
            </h2>
            <p className="text-base md:text-lg lg:text-xl max-w-2xl mx-auto" style={{ color: '#836FFF' }}>
              Play, earn, and be part of the Swapper Community
            </p>
          </div>

          {/* Feature Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 max-w-7xl mx-auto">
            {features.map((feature) => (
              <Link
                key={feature.title}
                href={feature.href}
                className="group relative bg-white rounded-2xl overflow-hidden transition-all duration-200 ease-out hover:-translate-y-1 hover:shadow-lg cursor-pointer"
              >
                {/* Image Container */}
                <div className="relative w-full aspect-[4/3] bg-gradient-to-br from-purple-50 to-white overflow-hidden">
                  <Image
                    src={feature.image}
                    alt={feature.title}
                    fill
                    className="object-cover transition-transform duration-200 ease-out group-hover:scale-105"
                  />
                </div>

                {/* Text Content */}
                <div className="p-6 space-y-3">
                  <h3 className="text-xl md:text-2xl font-bold text-swapper-secondary">
                    {feature.title}
                  </h3>
                  <p className="text-swapper-secondary/70 text-sm md:text-base leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
